import { IImageFile } from '../../../types/imageFile';

export enum EImageOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Square = 'square',
}

export const useImageOrientation = (image: IImageFile): EImageOrientation => {
  const { width, height } = image;

  if (!width || !height) {
    return EImageOrientation.Square;
  }

  if (width > height) {
    return EImageOrientation.Horizontal;
  } else if (width < height) {
    return EImageOrientation.Vertical;
  } else {
    return EImageOrientation.Square;
  }
};
